export function camelize(str) {
    return (str || "").toLowerCase().replace(/\b\w/g, s => s.toUpperCase());
}

export function snakeCaseToPascalCase(str, prefix = "", plural = "") {
    const camelize = str.replace(/_\w/g, (m) => m[1].toUpperCase());
    const pascalCase = camelize.substring(0, 1).toUpperCase() + camelize.substring(1);
    return `${prefix}${pascalCase}${plural}`;
}
